export enum FileType {
  CSV = 'csv',
  PDF = 'pdf',
  XLS = 'xls',
  XLSX = 'xlsx',
  CHART = 'chart'
}

export function getTabularFileTypes(): ReadonlyArray<FileType> {
  return [FileType.CSV, FileType.PDF, FileType.XLSX];
}

export function getChartFileTypes(): ReadonlyArray<FileType> {
  return [FileType.CHART];
}
